import io from "socket.io-client"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {Main} from "./pages/main"
//import {Game} from "./pages/game"
//import {Results} from "./pages/results"
import { createContext } from "react";
import { useState } from "react";
import {Game} from "./pages/game"
import "./App.css"
import "./index.css"
import {ImagePage} from "./pages/cartoon"
import { useEffect } from "react";
import {FusePage} from "./pages/fusepage"
import {Profile} from "./pages/profile"

// Create a new context
export const NicknameContext = createContext();
export const RoomContext = createContext()
export const UserContext = createContext()
export const InputFilesContext = createContext()



// Create a provider component
export const NicknameProvider = ({ children }) => {
  const [nickname_GLOBAL, setNickname_GLOBAL] = useState('');

  return (
    <NicknameContext.Provider value={{ nickname_GLOBAL, setNickname_GLOBAL }}>
      {children}
    </NicknameContext.Provider>
  );
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user')));

  useEffect(() => {
    const user1 = JSON.parse(localStorage.getItem('user'))
 //   console.log("UU",user1)
    setUser(user1)
  }, [])

  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user))
 //   console.log("UUU",user)
  }, [user])

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}


export const socket = io("https://www.cotdamn.com")

export const RoomProvider = ({ children }) => {
  const [room,setRoom] = useState('');

  return (
    <RoomContext.Provider value={{ room, setRoom }}>
      {children}
    </RoomContext.Provider>
  );
};

export const InputFilesProvider = ({ children }) => {
  const [inputFiles, setInputFiles] = useState([]);

  return (
    <InputFilesContext.Provider value={{ inputFiles, setInputFiles }}>
      {children}
    </InputFilesContext.Provider>
  );
};



function App() {

  return (
    <div className="App mb-5">
      
      <Router>
        <NicknameProvider>
          <RoomProvider>
            <UserProvider>
              <InputFilesProvider>
          <Routes>
            <Route path="/" element={<Main/>}/>
          {/*}  <Route path="/game" element={<Game/>}/>
            <Route path="/results" element={<Results/>}/>*/}
         <Route path="/image/:id" element={<ImagePage/>}/>
         <Route path="/fuse" element={<FusePage/>}/>
         <Route path="/profile" element={<Profile/>}/>
      
          </Routes>
          </InputFilesProvider>
          </UserProvider>
          </RoomProvider>
        </NicknameProvider>
        
      </Router>
    </div>
  );
}

export default App;









